export default class ConsoleUtil {
    static log(...args: any[]) {
        console.log(...args)
    }

    static trace(...args: any[]) {
        console.trace(...args)
    }
}
